import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  // Inject the AuthService to use its token validation logic
  const authService = inject(AuthService);
  
  // Define endpoints that explicitly DON'T need authentication (whitelist approach)
  const PUBLIC_ENDPOINTS = [
    '/api/user/login',
    '/api/user/authenticate',
    '/api/user/register'  // Only the PUBLIC register endpoint, NOT admin-only
  ];

  // Check if this is a public endpoint that doesn't need authentication
  const isPublicEndpoint = PUBLIC_ENDPOINTS.some(endpoint => 
    req.url.endsWith(endpoint) || req.url.includes(endpoint + '?')
  );

  if (isPublicEndpoint) {
    console.log('Auth Interceptor - Public endpoint, skipping auth:', req.url);
    return next(req);
  }

  // For ALL other endpoints (including admin-only), add the auth token
  const token = authService.getToken();

  if (token) {
    console.log('Auth Interceptor - Protected endpoint, adding auth token:', req.url);
    const clonedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    return next(clonedReq);
  }

  // No token available for protected endpoint - this should not happen if guards are working
  console.error('Auth Interceptor - No token available for protected endpoint:', req.url);
  console.error('This indicates a potential auth guard bypass or token expiry issue');
  
  // Still pass the request through, but it will likely get a 401 response from the server
  return next(req);
};